import { MerchantUserDto } from '@/models/club';
import { useGetImage } from '@/utilities/helper/getImage';
import { Avatar, Group, Text } from '@mantine/core';

type Props = {
    user: MerchantUserDto;
}

function TeamItem({ user }: Props) {
    const { imageUrl } = useGetImage({ image: user?.image });
    return (
        <Group>
            <Avatar
                variant="outline"
                color="blue"
                radius="xl"
                size="md"
                src={imageUrl}
                p="3"
                styles={{
                    image: {
                        borderRadius: "100px",
                    },
                    root: {
                        border: `2px solid ${user?.calendarColor}`,
                    },
                }}
            >
                {user?.firstName?.charAt(0) || ""}
            </Avatar>
            <Text>
                {user?.firstName} {user?.lastName}
            </Text>
        </Group>
    )
}

export default TeamItem;